__turbopack_context__.v({
  "button": "PrivacyEmbedConsent-module-scss-module__qO7f-W__button",
  "header": "PrivacyEmbedConsent-module-scss-module__qO7f-W__header",
  "wrapper": "PrivacyEmbedConsent-module-scss-module__qO7f-W__wrapper",
});
